import { MultiAutocomplete } from "Components/UI/Atoms/CustomAutocomplete"

export const Settings = (
  concept,
  edit,
  setSelectedConcept,
  constants
) => {

  return [
    {
      class: 'custom',
      component: (
        <MultiAutocomplete
          name="puertas"
          options={constants.puertas || []}
          getOptionLabel={(e) => e.tipo}
          value={(constants?.puertas || []).filter((p) =>
            concept?.puertas?.includes(p.value)
          )}
          label="Puertas"
          onChange={(_, value) => {
            setSelectedConcept({
              ...concept,
              puertas: value.map((v) => v.value)
            })
          }}
          tagName="tipo"
          heightInput="auto"
          disabled={!edit}
        />
      ),
      sm: 6,
      xs: 12,
    },
    {
      class: 'custom',
      component: (
        <MultiAutocomplete
          name="traccion"
          options={constants.tracciones || []}
          getOptionLabel={(e) => e.tipo}
          value={(constants?.tracciones || []).filter((p) =>
            concept?.traccion?.includes(p.value)
          )}
          label="Tracción"
          onChange={(_, value) => {
            setSelectedConcept({
              ...concept,
              traccion: value.map((v) => v.value)
            })
          }}
          tagName="tipo"
          heightInput="auto"
          disabled={!edit}
        />
      ),
      sm: 6,
      xs: 12,
    },
    {
      class: 'custom',
      component: (
        <MultiAutocomplete
          name="combustible"
          options={constants.combustibles}
          getOptionLabel={(e) => e.tipo}
          value={(constants?.combustibles || []).filter((p) =>
            concept?.combustible?.includes(p.value)
          )}
          label="Combustible"
          onChange={(_, value) => {
            setSelectedConcept({
              ...concept,
              combustible: value.map((v) => v.value)
            })
          }}
          tagName="tipo"
          heightInput="auto"
          disabled={!edit}
        />
      ),
      sm: 6,
      xs: 12,
    }, 
    {
      class: 'custom',
      component: (
        <MultiAutocomplete
          name="turbo"
          options={constants.turbos}
          getOptionLabel={(e) => e.tipo}
          value={(constants?.turbos || []).filter((p) =>
            concept?.turbo?.includes(p.value)
          )}
          label="Turbo"
          onChange={(_, value) => {
            setSelectedConcept({
              ...concept,
              turbo: value.map((v) => v.value)
            })
          }}
          tagName="tipo"
          heightInput="auto"
          disabled={!edit}
        />
      ),
      sm: 6,
      xs: 12,
    }, 
    {
      class: "autocomplete",
      sm: 12,
      xs: 12,
      options: constants?.transmisiones || [],
      name: "transmision",
      label: "Transmisión",
      optionLabel: `options["tipo"]`,
      optionValue: "value",
      value: concept?.transmision,
      defaultValue: constants?.transmisiones.find((v) => v.value === concept?.transmision),
      disabled: !edit,
      onChange: (e) => {
        setSelectedConcept({
          ...concept,
          transmision: e ? e.value : null
        })
      },
    },   
  ]
}